var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuratedLogoDark = function SvgQuratedLogoDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "qurated-logo-dark_svg__Nav_link__xIf3s qurated-logo-dark_svg__Nav_quratedLogo__TWxrt",
    "data-name": "Qurated Home Icon",
    viewBox: "0 0 69.423 69.155"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2bd675",
    d: "M42.272 61.117a2.9 2.9 0 1 0 2.846-2.952 2.9 2.9 0 0 0-2.846 2.952",
    "data-name": "Path 589"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2bd675",
    d: "M51.429 61.117a2.9 2.9 0 1 0 2.846-2.952 2.9 2.9 0 0 0-2.846 2.952",
    "data-name": "Path 590"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2bd675",
    d: "M60.578 61.117a2.9 2.9 0 1 0 2.846-2.952 2.9 2.9 0 0 0-2.846 2.952",
    "data-name": "Path 591"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#405767",
    d: "M37.713 62.963a2.274 2.274 0 0 1-.381.068 28.384 28.384 0 1 1 24.36-19.267 2.26 2.26 0 1 1-4.285-1.44 23.867 23.867 0 1 0-20.491 16.21 2.26 2.26 0 0 1 .794 4.432Z",
    "data-name": "Path 580"
  })));
};
export default SvgQuratedLogoDark;